import React from 'react';
import { ZuoraPaymentMethod } from '@klab-berlin/api-sdk/lib/services/billing';

import { ZuoraPaymentPageClientSideErrorHandler, ZuoraPaymentPageResponse } from '../../types/ZuoraPayments';
import { UserPaymentMethodType } from '../../types/User';
import usePaymentSetup from '../../utils/usePaymentSetup';
import PaymentZouraContent from './PaymentZouraContent';
import PaymentPaypalContent from './PaymentPaypalContent';
import PaymentInvoiceContent from './PaymentInvoiceContent';

interface PaymentContentProps {
    selectedMethod: string;
    onResponseHandler: (paymentMethod: ZuoraPaymentMethod, response: ZuoraPaymentPageResponse) => void;
    onClientSideErrorHandler?: ZuoraPaymentPageClientSideErrorHandler
    zuoraHostedPagesSource: string
}

const PaymentContent = ({
  selectedMethod,
  onResponseHandler,
  onClientSideErrorHandler,
  zuoraHostedPagesSource,
}: PaymentContentProps) => {

  const { paypalToken, hasCreditCardErrors } = usePaymentSetup({
    selectedMethod,
    onResponseHandler,
    onClientSideErrorHandler,
    zuoraHostedPagesSource
  });

  switch (selectedMethod) {
    case UserPaymentMethodType.SEPA:
    case UserPaymentMethodType.CREDIT_CARD:
      return (
        <PaymentZouraContent method={selectedMethod} hasCreditCardErrors={hasCreditCardErrors} />
      );
    case UserPaymentMethodType.PAYPAL:
      return (
        <PaymentPaypalContent paypalToken={paypalToken} onResponseHandler={onResponseHandler} />
      );
    case UserPaymentMethodType.INVOICE:
      return (
        <PaymentInvoiceContent />
      );
    default:
      return null;
  }
};

export default PaymentContent;
